import React from 'react'
import Dashboard from '../../dashboard'
import AssignToOperatorView from './page'

const AssignToOperator = () => {
  return <Dashboard component={<AssignToOperatorView />} />
}

export default AssignToOperator
